'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Chip = require('./Chip');

var _Chip2 = _interopRequireDefault(_Chip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Chip2.default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/Chip/index.js
 ** module id = 832
 ** module chunks = 0
 **/